export const getErrorMesage = (error: any): string =>
  (error.response && error.response.data.message) || error.message
